<template>
    <div v-if="Object.keys(doughnutChartVisitacaoAtrativoCity).length > 0">
        <doughnut-chart id="bar-chart-visitacao" :height="height"
            :chart-data="doughnutChartVisitacaoAtrativoCity.chartData"
            :extra-options="doughnutChartVisitacaoAtrativoCity.extraOptions">
        </doughnut-chart>
    </div>
</template>

<script>
import DoughnutChart from '@/components/Charts/DoughnutChart';
import defaultChartObjects from '../defaultChartObjects';
import { mapActions, mapGetters } from 'vuex'

export default {
    component: 'DoughnutChartAtrativo',

    components: {
        DoughnutChart,
    },

    props: {
        height: {
            type: Number,
            default: 250
        },

        colors: {
            type: Array,
            default: []
        },

        hideDoughnut: {
            type: Boolean,
            default: false
        },

        fetchProgress: {
            type: Number,
            default: 0 | 100
        },

        transformedItemsArray: {
            type: Array,
            default: [],
        },

        byCityGraphLevel: {
            type: Number,
            default: 8,
        },

        defaultBarThickness: {
            type: Number,
            default: 8,
        },

        selectedbillItensNames: {
            type: Array | Object,
            default: [] | {},
        },
    },

    data: () => {
        return {
        }
    },

    methods: {
        ...mapActions('product', [
            "productStoreCommit",
        ]),
        //METHOD TO GROUP BY KEYGETTER.
        //KEYGETTER MUST BE "foo => foo.fieldYouWantToGroupBy"
        groupBy(list, keyGetter) {
            const map = new Map();
            list.forEach((item) => {
                const key = keyGetter(item);
                const collection = map.get(key);
                if (!collection) { map.set(key, [item]); }
                else { collection.push(item); }
            });
            return Array.from(map);
        },
    },

    computed: {
        ...mapGetters('product', {
            useChartCache: "getUseChartCache",
            cacheObject: "getDoughnutChartVisitantes",
        }),

        doughnutChartVisitacaoAtrativoCity() {

            var defaultChart = {}
            defaultChart = JSON.parse(JSON.stringify(defaultChartObjects.defaultDoughnutChartVisitantes))

            if (this.useChartCache && this.cacheObject.chartData != undefined && this.cacheObject.chartData.labels.length > 0) {
                defaultChart = JSON.parse(JSON.stringify(this.cacheObject))
            }

            if (this.fetchProgress < 100) {
                sessionStorage.removeItem('SET_DOUGHNUT_CHART_ATRATIVO_save')
                return defaultChart
            }

            else if (this.fetchProgress == 0 || this.fetchProgress == 100) {
                var billItems = []
                let chartTotalCount = 0
                var labels = []

                billItems = this.transformedItemsArray.filter(el => {
                    return this.selectedbillItensNames.length <= 1 || this.selectedbillItensNames.includes(el.poi.product_name)
                })

                var dados = this.groupBy(billItems, el => {
                    if (el.allcats.length) {
                        //use deeper product category this.byCityGraphLevel
                        let deeper_cat_key = Object.keys(el.allcats).slice(-1)
                        deeper_cat_key = deeper_cat_key.pop()
                        let deeper_cat = el.allcats[deeper_cat_key]
                        let deeper_cat_parent_id = deeper_cat[0].parent

                        //if product category is deeper then graph max graph max level
                        if (el.allcats.length >= this.byCityGraphLevel) {
                            //use first category of parent level by default
                            deeper_cat = [el.allcats[this.byCityGraphLevel - 1][0]]

                            //or search for the direct parent in parent level
                            Object.values(el.allcats[this.byCityGraphLevel - 1]).forEach((item) => {
                                if (item.term_id == deeper_cat_parent_id) { deeper_cat = [item]; return }
                            })
                        }
                        deeper_cat = deeper_cat.slice(-1).pop()
                        return deeper_cat.name

                    }
                    else {
                        return el.cat && el.cat.length > 0 && el.cat.includes('-') ? el.cat.split('-')[0] : el.cat ? el.cat : 'Outro Local'
                    }
                })

                labels = dados.map(function (val) { return val[0] }).sort()

                //GROUPPING BY PRODUCT (OR Trilha)
                dados = this.groupBy(dados, el => el[1].map(function (val, idx) { return val.poi.product_name }))

                // FROM dados, ACESSING THE BILLS AND GETTING THE AMOUNT OF VISITS IN THE RESPECTIVE PRODUCT
                var POILabels = dados.map(function (val, idx) {
                    var amount = val[1][0][1].map(function (value) {
                        var arrayQntd = value.people.tableText.count
                        chartTotalCount += arrayQntd
                        return arrayQntd;
                    })

                    // POI: PRODUCTS WITHOUT DUPLICATES
                    // CIDADE: PLACE THAT HAS THE PRODUCT
                    // AMOUNT_POI: AMOUNT OF VISITS OF THE PRODUCT
                    return { POIs: val[0].filter((v, i, a) => a.indexOf(v) === i), cidade: val[1][0][0], amountPOIs: amount };
                })

                // data to the tooltip. It will contain a product label and
                // a array with the amount of visits in the respective index to the city

                // data to the tooltip. It will contain the amount of products to the city
                var amountPerLabel = new Array(labels.length).fill(0)

                //SETTING THE PRODUCTS(NAME AND AMOUNT) TO THE RESPECTIVE PLACE
                POILabels.map(function (value, index) {
                    var cidade = value.cidade
                    const labelIndexCity = labels.indexOf(cidade)
                    amountPerLabel[labelIndexCity] = value.amountPOIs.reduce((prev, curr) => new Number(prev) + new Number(curr), 0);
                    labels[labelIndexCity] += ' (' + (amountPerLabel[labelIndexCity] * 100 / chartTotalCount).toFixed(2).replace('.', ',') + '%)'
                })


                // REMOVING VALUES WITH AMOUNT == 0 OR NULL/UNDEFINED
                defaultChart = {
                    chartData: {
                        labels: labels,
                        datasets: [{
                            data: amountPerLabel,
                            backgroundColor: this.colors,
                            barThickness: this.defaultBarThickness,
                            maxBarThickness: this.maxBarThickness,
                        }],
                    },
                    extraOptions: {
                        cutoutPercentage: this.hideDoughnut ? 100 : defaultChart.extraOptions.cutoutPercentage,
                        legend: {
                            display: true,
                            position: 'bottom',
                        },
                        tooltips: {
                            mode: 'point',
                            callbacks: {
                                label: function (tooltipItem, data) {
                                    return data.labels[tooltipItem.index] + ': ' + data.datasets[0]['data'][tooltipItem.index] + ' visitantes'
                                }
                            }
                        },
                    }
                }

                if (this.useChartCache == true && this.fetchProgress == 100 && !sessionStorage.getItem('SET_DOUGHNUT_CHART_ATRATIVO_save')) {
                    sessionStorage.setItem('SET_DOUGHNUT_CHART_ATRATIVO_save', '1')
                    this.productStoreCommit({ mutation: "SET_DOUGHNUT_CHART_ATRATIVO", value: JSON.parse(JSON.stringify(defaultChart)) })
                }

                return defaultChart;
            }
        },

    },
}
</script>
